// extracted by mini-css-extract-plugin
export default {"rotate":"style_rotate__cCJop","userInfoContainer":"style_userInfoContainer__XrwNA","arrow":"style_arrow__+7A7V"};